<template>
	<div class="column rigid">
		<div class="table">
			<div class="row">
				<div class="gap label">
					<div class="placeholder"></div>
				</div>
				<footer class="value rigid">
					<div class="placeholder"></div>
				</footer>
			</div>
			<div class="row">
				<div class="gap label">
					<div class="placeholder"></div>
				</div>
				<footer class="value rigid">
					<div class="placeholder"></div>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TablePlaceholder'
};
</script>

<style scoped>
	.plan-option.empty {
		width: 100%;
	}
	.label .placeholder {
		width: 100px;
	    background: #ddd;
	    height: 1.2em;
	}
	.value .placeholder {
		width: 50px;
		background: #f6f6f6;
		 height: 1.2em;
	}
	div.row:last-child .value .placeholder {
		width: 50px;
		background: #ddd;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/TablePlaceholder.vue